import React from "react";

const Contact = () => {
  return (
    <div
      name="contact"
      className="w-full h-auto py-6 bg-gradient-to-b from-black to-gray-800 text-white"
    >
      <div
        className="flex flex-col p-4 justify-center
      max-w-screen-lg w-full h-full mx-auto"
      >
        <div className="pb-8">
          <p
            className="text-4xl font-bold inline
           border-b-4 border-gray-500"
          >
            Contact
          </p>
          <p className="py-6">Submit the form below to get in touch with me</p>
        </div>

        <div className="flex justify-center items-center">
          <form
            action="https://getform.io/f/671ae5ff-a4c8-4c26-8320-3cdcd435c364"
            method="POST"
            className="flex flex-col w-full md:w-1/2"
          >
            <input
              type="text"
              name="name"
              placeholder="Enter your name"
              className="p-2 border-2 bg-transparent rounded-md focus:outline-none"
            />

            <input
              type="text"
              name="email"
              placeholder="Enter your email"
              className="p-2 border-2 bg-transparent rounded-md my-4 focus:outline-none"
            />

            <textarea
              type="text"
              name="message"
              rows="10"
              placeholder="Enter your message"
              className="p-2 border-2 bg-transparent rounded-md focus:outline-none"
            />

            <button
              className="bg-gradient-to-b from-cyan-500
            to to-blue-400 rounded-md text-white shadow-lg shadow-sky-500/30 px-6 py-3 my-8 mx-auto flex items-center hover:scale-110 duration-300"
            >
              Let's talk
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Contact;
